.page {
  position: absolute;
  inset: 0;
  background: #000;
}

.feedHost {
  position: absolute;
  inset: 0 0 var(--feed-bottom, var(--bottom-chrome)) 0;
}

.feedHost[hidden] {
  display: none;
}

/* ---------- top bar ---------- */
.topBar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 20;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: calc(var(--safe-t) + 8px) 8px 8px;
  background: linear-gradient(to bottom, rgb(0 0 0 / 0.55), transparent);
  pointer-events: none;
}

.topBar > * {
  pointer-events: auto;
}

.brand {
  padding-left: 8px;
  color: white;
  display: flex;
}

.feedTabs {
  display: flex;
  gap: 18px;
}

.feedTab {
  position: relative;
  font-weight: 700;
  font-size: var(--fs-md);
  color: rgb(255 255 255 / 0.6);
  padding: 6px 2px;
  text-shadow: 0 1px 6px rgb(0 0 0 / 0.5);
  transition: color var(--t-fast);
}

.feedTabActive {
  color: white;
}

.feedTabActive::after {
  content: '';
  position: absolute;
  left: 25%;
  right: 25%;
  bottom: 0;
  height: 3px;
  border-radius: 3px;
  background: var(--accent);
}

.topActions {
  display: flex;
  justify-content: flex-end;
  gap: 2px;
}

.topIcon {
  position: relative;
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: white;
  filter: drop-shadow(0 1px 4px rgb(0 0 0 / 0.5));
}

.dot {
  position: absolute;
  top: 8px;
  right: 9px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--accent);
}

/* ---------- scroller ---------- */
.scroller {
  height: 100%;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  overscroll-behavior-y: contain;
  scrollbar-width: none;
}

.scroller::-webkit-scrollbar {
  display: none;
}

.slot {
  position: relative;
  height: 100%;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.loadingSlot {
  display: grid;
  place-items: center;
  height: 100%;
  color: var(--text-3);
}

.emptyWrap {
  display: grid;
  place-items: center;
  height: 100%;
}

/* ---------- card ---------- */
.card {
  position: absolute;
  inset: 0;
  overflow: hidden;
  background: #000;
  user-select: none;
}

.poster,
.video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.tapLayer {
  position: absolute;
  inset: 0;
  z-index: 1;
}

.shade {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 45%;
  background: linear-gradient(to top, rgb(0 0 0 / 0.7), transparent);
  pointer-events: none;
  z-index: 1;
}

.pausedIcon {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  color: rgb(255 255 255 / 0.85);
  z-index: 2;
  pointer-events: none;
  animation: bb-fade-in var(--t-fast) var(--ease);
  filter: drop-shadow(0 4px 20px rgb(0 0 0 / 0.5));
}

.buffering {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 40px;
  height: 40px;
  margin: -20px 0 0 -20px;
  border-radius: 50%;
  border: 3px solid rgb(255 255 255 / 0.2);
  border-top-color: white;
  animation: bb-spin 0.8s linear infinite;
  z-index: 2;
  pointer-events: none;
}

.heartBurst {
  position: absolute;
  z-index: 3;
  color: var(--accent);
  pointer-events: none;
  transform: translate(-50%, -50%);
  animation: burst 0.9s var(--ease) forwards;
  filter: drop-shadow(0 6px 20px rgb(var(--accent-rgb) / 0.5));
}

@keyframes burst {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.4) rotate(-12deg);
  }
  20% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.15) rotate(-6deg);
  }
  40% {
    transform: translate(-50%, -50%) scale(0.95);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -140%) scale(1.1);
  }
}

.unmutePill {
  position: absolute;
  top: calc(var(--safe-t) + 64px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 4;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: var(--r-full);
  background: rgb(0 0 0 / 0.55);
  backdrop-filter: blur(10px);
  font-size: var(--fs-sm);
  font-weight: 700;
  animation: bb-fade-in var(--t-med) var(--ease);
}

/* ---------- rail ---------- */
.rail {
  position: absolute;
  right: 8px;
  bottom: 22px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.railAvatar {
  position: relative;
  margin-bottom: 8px;
}

.railAvatar a > span {
  box-shadow: 0 0 0 2px white;
}

.followPlus {
  position: absolute;
  bottom: -9px;
  left: 50%;
  transform: translateX(-50%);
  display: grid;
  place-items: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--accent);
  color: var(--accent-ink);
  transition: transform var(--t-fast) var(--ease-spring);
}

.followPlus:active {
  transform: translateX(-50%) scale(0.85);
}

.railBtn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  color: white;
  filter: drop-shadow(0 1px 5px rgb(0 0 0 / 0.45));
}

.railIcon {
  display: grid;
  place-items: center;
  width: 44px;
  height: 40px;
  transition: transform var(--t-fast) var(--ease);
}

.railBtn:active .railIcon {
  transform: scale(0.88);
}

.railCount {
  font-size: 12px;
  font-weight: 700;
}

.railActive {
  color: var(--accent);
}

.railActive .railCount {
  color: white;
}

.pop .railIcon {
  animation: bb-pop 0.35s var(--ease-spring);
}

.disc {
  display: grid;
  place-items: center;
  width: 46px;
  height: 46px;
  margin-top: 6px;
  border-radius: 50%;
  background: conic-gradient(from 0deg, #222, #444, #222, #333, #222);
  border: 8px solid #161616;
  overflow: hidden;
}

.disc img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.discSpin {
  animation: bb-spin 5s linear infinite;
}

/* ---------- meta ---------- */
.meta {
  position: absolute;
  left: 14px;
  right: 76px;
  bottom: 20px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-shadow: 0 1px 6px rgb(0 0 0 / 0.5);
}

.author {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 800;
  font-size: var(--fs-md);
  align-self: flex-start;
}

.followingTag {
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: var(--r-full);
  background: rgb(255 255 255 / 0.16);
  text-shadow: none;
}

.caption {
  font-size: var(--fs-sm);
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  cursor: pointer;
}

.captionOpen {
  -webkit-line-clamp: unset;
}

.soundChip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 72%;
  align-self: flex-start;
  padding: 6px 12px 6px 10px;
  border-radius: var(--r-full);
  background: rgb(0 0 0 / 0.35);
  backdrop-filter: blur(8px);
  font-size: var(--fs-sm);
  font-weight: 600;
  overflow: hidden;
}

.marquee {
  overflow: hidden;
  white-space: nowrap;
  mask-image: linear-gradient(to right, transparent, black 6%, black 90%, transparent);
}

.marquee span {
  display: inline-block;
  padding-left: 6%;
  animation: marquee 9s linear infinite;
}

@keyframes marquee {
  0%,
  15% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-60%);
  }
}

/* ---------- sound control ---------- */
.soundCtl {
  position: absolute;
  top: calc(var(--safe-t) + 60px);
  right: 10px;
  z-index: 4;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px;
  border-radius: var(--r-full);
  background: rgb(0 0 0 / 0.35);
  backdrop-filter: blur(8px);
}

.soundCtl button {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  color: white;
}

.soundCtl input {
  width: 0;
  opacity: 0;
  accent-color: var(--accent);
  transition: width var(--t-med) var(--ease), opacity var(--t-med);
}

@media (hover: hover) {
  .soundCtl:hover input,
  .soundCtl:focus-within input {
    width: 90px;
    opacity: 1;
    margin-right: 8px;
  }
}

/* ---------- progress ---------- */
.progress {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 14px;
  z-index: 4;
  display: flex;
  align-items: flex-end;
  cursor: pointer;
  touch-action: none;
}

.progress span {
  display: block;
  width: 100%;
  height: 2px;
  background: rgb(255 255 255 / 0.85);
  transform-origin: left;
  transition: height var(--t-fast);
}

.progress:hover span,
.progress:active span {
  height: 4px;
}

/* ---------- skeleton ---------- */
.skeleton {
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at 50% 40%, var(--surface-2), #000 70%);
}

.skeletonMeta {
  position: absolute;
  left: 14px;
  right: 90px;
  bottom: 26px;
  display: grid;
  gap: 10px;
}

.skeletonRail {
  position: absolute;
  right: 14px;
  bottom: 40px;
  display: grid;
  gap: 22px;
}
